export class CustomChartOptions {
    columns = [];
    data: any;
    prgressbarClass = '';
    maxValues: any;
}
